<!--立项交付-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add()" v-permission="['project:add']">新增</el-button>
          <!-- <el-button icon="el-icon-plus" :disabled="isDisabled" @click="exportList()">批量导出</el-button> -->
          <el-button icon="el-icon-upload1" @click="exportDataList()">导出</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        border
        :toolBar="{label: '操作',hidden: false,fixed: 'right',width:'200px',align:'center'}"
        @selection-change="handleSelectionChange"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #planDeviance="{row}">
            <el-tag type="warning" v-if="row.planDeviance >= 0.7 && row.planDeviance < 0.9 ">中等</el-tag>
            <el-tag type="danger" v-else-if="row.planDeviance >= 0.9">高等</el-tag>
            <span v-else>正常</span>
        </template>
        <template #contractDelivery="{row}">
          <el-tag v-if="row.contractDelivery && row.contractDelivery.contractType && row.contractDelivery.contractType === '1'">{{row.contractDelivery.contractName}}</el-tag>
          <el-tag v-if="row.contractDelivery && row.contractDelivery.contractType && row.contractDelivery.contractType === '2'" type="warning">{{row.contractDelivery.contractName}}</el-tag>
        </template>
        <template #collectMoney="{row}">
          <el-tag type="info" v-if="row.collectMoney == null">0</el-tag>
          <el-tag type="info" v-else>{{row.collectMoney}}</el-tag>
        </template>
        <template #toolbar="scope">
           <el-button v-if="scope.row.billState != 9 && !statusEdit(scope.row.billState)" type="text" size="mini" @click="changeDelivery(scope.row)">立项变更</el-button>
           <el-button v-if="isAdmin && scope.row.billState != 9" type="text" size="mini" @click="superChangeDelivery(scope.row)">超级变更</el-button>
           <el-popover :ref="scope.row.id " placement="top" width="180">
              <p>确定关闭本条立项数据吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
                <el-button type="primary" size="mini" @click="closeDelivery(scope.row.id)">确定</el-button>
              </div>
              <el-button v-if="isAdmin && scope.row.billState != 9" type="text" size="mini" slot="reference">关闭</el-button>
            </el-popover>
           <!-- <el-button icon="el-icon-upload2" type="text" size="mini" @click="downloadExcel(scope.row)"></el-button> -->
           <el-button type="text" size="mini" icon="el-icon-view" @click="view(scope.row)"></el-button>
           <el-button type="text" size="mini" icon="el-icon-edit" v-if="statusEdit(scope.row.billState) && scope.row.billState != 9" @click="edit(scope.row)"></el-button>
            <!-- <el-popover
            :ref="scope.row.id"
            placement="top"
            width="220"
             v-if="scope.row.billState ===2"
          >
            <p>确定退回该立项交付单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
               <el-button type="primary" size="mini" @click="reject(scope.row)">退回</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-back" slot="reference"></el-button>
          </el-popover> -->
           <!-- <el-popover
            :ref="scope.row.id"
            placement="top"
            width="180"
             v-if="statusUnAudit(scope.row.billState)"
          >
            <p>确定反审核该立项交付单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
               <el-button type="primary" size="mini" @click="reject(scope.row, 5)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-circle-close" slot="reference"></el-button>
          </el-popover> -->
          <el-popover :ref="scope.row.id" placement="top" width="180" v-if="statusEdit(scope.row.billState)">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
            </div>
            <el-button v-if="scope.row.billState != 9" type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { delProjectDelivery,addProjectDelivery, closeProjectDelivery } from "@/api/basic";
import {tableSataus} from '@/views/bill/mixins/status'
import { downloadExcel,exportListDataExcel} from "@/api/bill/contract"
import { exportProjectList } from "@/api/bill/contract"
export default {
  name: "DeliveryIndex",
  components: {
    DynamicSearch
  },
  mixins: [DataTableMixin,tableSataus],
  data() {
    return {
      tableHead: [
        {
          label: "项目名",
          prop: "projectName",
          width: '120',
          query: {
            type: "input"
          },
          fixed: 'left'
        },
       {
          label: "项目号",
          prop: "projectNumber",
          width: '120',
          query: {
            type: "input"
          },
          fixed: 'left'
        },
        {
          label: "创建人",
          prop: "creatorObj.name",
          width: '90',
        },
         {
          label: "合同",
          prop: "contractDelivery",
          width: '120',
        },
        {
          label: '终端客户',
          prop: 'customerMain',
          width: '120',
          query: {
            type: 'input'
          },
        },
        {
          label: "合同总金额",
          prop: "contractDelivery.totals",
           width: '110'
        },
         {
          label: "收款金额",
          prop: "collectMoney",
          width: '110'
        },
        {
          label: "项目负责人",
          prop: "personManager.name",
          width: '110',
        },
        {
          label: "交付成本",
          prop: "costBudgeting",
          width: '110',
        },
         {
          label: "人工成本结余",
          prop: "costBalance",
          width: '120px'
        },
        // {
        //   label: "费用预算",
        //   prop: "budget"
        // },
        {
          label: "费用预算结余",
          prop: "budgetBalance",
          width: '120'
        },
         {
          label: "风险金结余",
          prop: "riskFundBalance",
          width: '110'
        },
         {
          label: "实际消耗成本",
          prop: "totalActual",
          width: '120px'
        },
        {
          label: "计划完成日期",
          prop: "planCloseTime",
          width: '120px'
        },
        {
          label: "验收日期",
          prop: "checkDate",
          width: '120px'
        },
        {
          label: "维保日期",
          prop: "maintenanceDate",
          width: '120px'
        },
        {
          label: "创建日期",
          prop: "created",
          width: '140'
        },
        {
          label: "计划预警状态",
          prop: "planDeviance",
          width: '120'
        },
        {
          label: "部门",
          prop: "deptName"
        },
        {
          label: "状态",
          prop: "billState",
          width: '70',
          formatter: (state) => {
            return this.statusName(state)
          },
          fixed: 'right'
        }

      ],
      sels: [],
      isDisabled: true,
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  methods: {
    // 导出
    exportDataList() {
       var that = this;
      that.downloadLoading = that.$loading({
        lock: true,
        text: '数据导出中...,请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.7)'
      });
      exportListDataExcel(that);
    },
     // 导出
      downloadExcel(data) {
            // console.log(data.bsProject.customer.name);
        const dates = new Date();
        const years = dates.getFullYear();
        let months = dates.getMonth() + 1;
        const days = dates.getDate();
        if (months < 9) {
          months = '0' + months
        }
        const date = years + months + days
        const title = data.bsProject.customer.name + "-" + data.projectName + "-" + "立项" + date
        downloadExcel(data.id,title)
      },
      handleSelectionChange(val) {
          // 勾选
         if (val.length > 0) {
            this.isDisabled = false;  // 批量导出按钮可用
            this.sels = val;
        } else {
            this.isDisabled = true;   // 批量导出按钮不可用
        }
          this.sels = val;
        },
        exportList() {
            const clientIds = this.sels.map(item => { return item.id; }).join(',');
            exportProjectList(clientIds);
        },
    dataTableBeforeInit() {
      this._url = "/projectDelivery";
      const params = { page: this.page, size: this.offset,searchType: 1}; // searchType 1立项 2项目计划
      this._params = Object.assign(params, this._query);
      return true;
    },
    dynamicSearch() {},
     view(row) {
      // this.$router.push({path: "/bill/delivery/form" ,query: { id: row.id,isEdit: 0}});
         this.$router.push({name: "DeliveryForm" ,params: { id: row.id,isEdit: 0 }})
    },
    superChangeDelivery(row) {
      this.$router.push({name: "SuperDeliveryChangeForm", params: { id: row.id,isEdit: 1 }})
    },
    closeDelivery(id) {
      closeProjectDelivery(id).then(res => {
        this.dataTableInit();
        this.$notify({
          title: "关闭成功",
          type: "success",
          duration: 2500
        });
      });
    },
    changeDelivery(row) {
      this.$router.push({name: "DeliveryChangeForm", params: { id: row.id,isEdit: 1 }})
    },
    add() {
      //  this.$router.push({path: "/bill/delivery/form" ,query: {isEdit: 1}});
         this.$router.push({name: "DeliveryForm"})
    },
    edit(row) {
      // this.$router.push({path: "/bill/delivery/form" ,query: { id: row.id,isEdit: 1}});
         this.$router.push({name: "DeliveryForm" ,params: { id: row.id,isEdit: 1 }})
    },
    audit(data) { // 审核
      console.log(data)
      data.projectDelivery = {id: data.id,billState: 3}
      this.updata(data);
      this.$nextTick(() => {
        this.$refs[data.id].doClose()
      })
    },
    reject(data, status = 4) {
      // 4 退回  5 反审核
      data.projectDelivery = {id: data.id,billState: status}
      this.updata(data);
      this.$nextTick(() => {
        this.$refs[data.id].doClose()
      })
    },
    updata(data) {
      addProjectDelivery(data).then(res => {
        if (res.code === 200) {
          this.$notify({
            title: '操作成功',
            type: "success",
            duration: 2500
          });
          this.dataTableInit();
        }
      });
    },
    // 删除
    subDelete(id) {
      delProjectDelivery(id).then(res => {
        this.dataTableInit();
        this.$notify({
          title: "删除成功",
          type: "success",
          duration: 2500
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
